import { userStore } from '../stores';
import { userApiService } from '../api/userApiService';

class UserService {

  updateUserBalance = async () => {
    const balance = await userApiService.getBalance();
    userStore.setBalance(balance || 0);
  }

}

export const userService = new UserService();
